import React, { useState } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  SimpleGrid,
  StatGroup,
  Stat,
  StatLabel,
  StatNumber,
  IconButton,
  Flex,
  Image,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Icon,
  VStack,
} from '@chakra-ui/react';
import {
  FaArrowLeft,
  FaArrowRight,
  FaUtensils,
  FaInfoCircle,
  FaHandsHelping,
  FaMoneyBillWave,
  FaRunning,
  FaPaintBrush,
  FaTheaterMasks,
  FaLaptop,
  FaTree,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaUsers,
  FaStar,
  FaClock,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

// Import immagini
import Slider1 from '../images/ce-2025-1.jpg';
import Slider2 from '../images/ce-2025-2.jpg';
import Slider3 from '../images/ce-2025-3.jpg';
import Slider4 from '../images/ce-2025-4.jpg';
import munlab from '../images/ce-2025-munlab.jpg';
import logoMunlab from '../images/logo-munlab.png';

// Import componenti esterni
import ContactForm from './ContactForm';

// WidgetCard component for le attività proposte
const WidgetCard = ({
  icon,
  label,
  value,
  description,
  fontSize = 'lg',
  color = 'gray.700',
  borderColor,
  backgroundColor = 'gray.50',
}) => (
  <Box
    p={4}
    bg={backgroundColor}
    color={color}
    rounded="md"
    shadow="md"
    borderLeft="8px"
    borderColor={borderColor || color}
  >
    <Flex align="center" mb={2}>
      <Icon as={icon} w={6} h={6} color={color} />
      <Text ml={2} fontWeight="bold" fontSize="lg">
        {label}
      </Text>
    </Flex>
    <Stat>
      <StatNumber fontSize={fontSize}>{value}</StatNumber>
      <Text fontSize="sm" color="gray.500">
        {description}
      </Text>
    </Stat>
  </Box>
);

const CentroEstivo = ({ event }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  // Slider immagini
  const sliderImages = [Slider1, Slider2, Slider3, Slider4];
  const nextImage = () =>
    setCurrentImage((prev) => (prev + 1) % sliderImages.length);
  const prevImage = () =>
    setCurrentImage(
      (prev) => (prev - 1 + sliderImages.length) % sliderImages.length
    );

  // Testimonianze
  const testimonials = [
    {
      text: 'Esperienza fantastica, mio figlio si è divertito tantissimo!',
      author: 'Marta R.',
    },
    {
      text: "Gli animatori sono bravissimi e l'organizzazione è perfetta!",
      author: 'Giovanni P.',
    },
    {
      text: 'Un centro estivo di altissima qualità, torneremo sicuramente.',
      author: 'Laura M.',
    },
  ];
  const nextTestimonial = () =>
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  const prevTestimonial = () =>
    setCurrentTestimonial(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );

  // Dati per le informazioni aggiuntive in Accordion
  const infoUtili = [
    {
      id: 'cosa-portare',
      title: 'Cosa Portare',
      content: (
        <>
          <Text mb={2}>
            Per vivere al meglio le giornate con noi, ecco alcune cose utili da
            portare:
          </Text>
          <Box bg="gray.50" p={4} borderRadius="md" boxShadow="sm">
            <Text fontWeight="bold" mb={2}>
              Essenziali da mettere nello zaino:
            </Text>
            <ul style={{ paddingLeft: '20px' }}>
              <li>
                🧢 <b>Cappellino</b> – Per proteggerti dal sole nelle ore più
                calde.
              </li>
              <li>
                💧 <b>Borraccia</b> – Ti consigliamo di portarla già piena!
              </li>
              <li>
                🧴 <b>Crema solare e spray antizanzare</b> – Per proteggerti dai
                raggi UV e dalle punture.
              </li>
              <li>
                👕 <b>Un cambio completo</b> – Può sempre servire, specialmente
                dopo i giochi all’aperto. Puoi lasciare lo zainetto con il
                cambio al Munlab.
              </li>
              <li>
                🩳 <b>Per le attività con l&apos;acqua:</b> Costume da bagno,
                ciabatte e un asciugamano grande.
              </li>
            </ul>
          </Box>
        </>
      ),
      icon: <FaInfoCircle />,
    },
    {
      id: 'pasti',
      title: 'I Pasti',
      content: (
        <>
          <Box bg="gray.50" p={4} borderRadius="md" boxShadow="lg">
            <Text fontWeight="bold" mb={2}>
              Pranzo al Centro Estivo:
            </Text>
            <ul style={{ paddingLeft: '20px' }}>
              <li>
                🍱 <b>Pranzo al sacco</b> – Portato da casa.
              </li>
              <li>
                🥗 <b>Pasti dal &quot;Nascondiglio di Chieri&quot;</b> –
                Disponibili su prenotazione al costo di 5€. Puoi ordinarli
                direttamente in loco entro le <b>9:30 del mattino</b>.
              </li>
            </ul>
          </Box>
          <Box bg="gray.50" p={4} borderRadius="md" boxShadow="lg" mt={4}>
            <Text fontWeight="bold" mb={2}>
              Merende:
            </Text>
            <Text>
              Ogni bambino deve portare due merende, una per la mattina e una
              per il pomeriggio. Se vuoi ridurre gli sprechi, ti consigliamo di
              portare anche le posate riutilizzabili!
            </Text>
          </Box>
          <Box bg="gray.50" p={4} borderRadius="md" boxShadow="lg" mt={4}>
            <Text fontWeight="bold" mb={2}>
              Conservazione:
            </Text>
            <Text>
              Abbiamo a disposizione frigorifero e microonde per conservare e
              scaldare i pasti, ma ti suggeriamo di usare contenitori ermetici
              per mantenere il cibo fresco.
            </Text>
          </Box>
        </>
      ),
      icon: <FaUtensils />,
    },
    {
      id: 'sostegno',
      title: 'Sostegno alle Famiglie',
      content: (
        <>
          <Text mb={2}>
            Vogliamo che ogni bambino viva un’estate serena e inclusiva. Se hai
            esigenze particolari, siamo qui per trovare insieme la soluzione
            migliore!
          </Text>
          <Box bg="gray.50" p={4} borderRadius="md" boxShadow="lg">
            <Text fontWeight="bold" mb={2}>
              Possiamo offrire supporto per:
            </Text>
            <ul style={{ paddingLeft: '20px' }}>
              <li>📘 Bambini con DSA o BES.</li>
              <li>🤝 Adattamenti e assistenza personalizzata.</li>
              <li>
                📞 Ogni esigenza speciale: contattaci e ne parleremo insieme!
              </li>
            </ul>
          </Box>
          <Text mt={4} textAlign="center">
            ✉️ <b>Scrivici o chiamaci</b>, siamo sempre disponibili per darti
            una mano.
          </Text>
        </>
      ),
      icon: <FaHandsHelping />,
    },
    {
      id: 'pagamenti',
      title: 'Pagamenti',
      content: (
        <>
          <Text mb={2}>
            Offriamo diverse modalità di pagamento per rendere l’iscrizione
            semplice e veloce.
          </Text>
          <Box bg="gray.50" p={4} borderRadius="md" boxShadow="lg">
            <Text fontWeight="bold" mb={2}>
              Come puoi pagare:
            </Text>
            <ul style={{ paddingLeft: '20px' }}>
              <li>
                💳 <b>Online</b> – Con carta di credito o PayPal.
              </li>
              <li>
                🏦 <b>Bonifico bancario</b> – Troverai i dettagli nel tuo
                account.
              </li>
              <li>
                🏠 <b>In sede</b> – Puoi pagare in contanti, con Satispay o con
                carta.
              </li>
            </ul>
          </Box>
          <Box bg="gray.50" p={4} borderRadius="md" boxShadow="lg" mt={4}>
            <Text fontWeight="bold" mb={2}>
              Quando pagare:
            </Text>
            <ul style={{ paddingLeft: '20px' }}>
              <li>
                🔹 <b>Acconto</b> – Serve per confermare l’iscrizione.
              </li>
              <li>
                🔹 <b>Saldo</b> – Da versare entro il venerdì precedente alla
                settimana scelta.
              </li>
              <li>
                🔹 <b>Totale</b> – Per un unico pagamento e una rapida
                iscrizione.
              </li>
            </ul>
          </Box>

          <Box bg="gray.50" p={4} borderRadius="md" boxShadow="lg" mt={4}>
            <Text fontWeight="bold" mb={2}>
              Sconti disponibili:
            </Text>
            <ul style={{ paddingLeft: '20px' }}>
              <li>
                👨‍👩‍👧‍👦 <b>Sconto fratelli</b> – 10% di riduzione sulla quota del
                secondo figlio.
              </li>
              <li>
                📦 <b>MVP</b> – Tutte le settimane ad un prezzo
                vantaggiosissimo!
              </li>
            </ul>
          </Box>
        </>
      ),
      icon: <FaMoneyBillWave />,
    },
  ];

  return (
    <Box color="gray.800" fontFamily="body">
      {/* DESCRIZIONE GENERALE */}
      <Container
        maxW="container.lg"
        py={10}
        textAlign="center"
        bg="white"
        mt={8}
        borderRadius={8}
      >
        <Heading size="xl" color="blue.600" mb={3}>
          Benvenuti al Centro Estivo di CIL & Munlab 2025!
        </Heading>
        <Text fontSize="lg" lineHeight="tall">
          Trascorri un estate indimenticabile, dal 9 giugno al 5 settembre 2025,
          in un&apos;esperienza ricca di attività tematiche, creatività e
          divertimento. Le iscrizioni sono a numero chiuso per garantire un
          ambiente stimolante e accogliente.
        </Text>
      </Container>

      {/* INFO PRINCIPALI */}
      <Container maxW="container.lg" py={10}>
        <SimpleGrid columns={{ base: 1, md: 4 }} spacing={6}>
          {[
            {
              title: 'Dove?',
              icon: FaMapMarkerAlt,
              text1: 'Via Camporelle 50, Cambiano (TO)',
              text2: 'Uno spazio immerso tra cultura e natura',
            },
            {
              title: 'Quando?',
              icon: FaCalendarAlt,
              text1: '9 Giugno - 5 Settembre',
              text2:
                'Da lunedì a venerdì, dalle 9:00 alle 17:00 (copertura dalle 8 alle 18)',
            },
            {
              title: 'Per Chi?',
              icon: FaUsers,
              text1:
                'Ragazzi e ragazze dalla prima elementare alla prima superiore',
              text2: 'Attività adatte a ogni età',
            },
            {
              title: 'Il Costo?',
              icon: FaMoneyBillWave,
              text1: '100€ a settimana',
              text2: 'Sconti per fratelli e pacchetti',
            },
          ].map((item) => (
            <WidgetCard
              key={item.title}
              icon={item.icon}
              label={item.title}
              value={item.text1}
              description={item.text2}
              fontSize="md"
              borderColor="blue.600"
              backgroundColor="gray.100"
              color="gray.700"
              p
            />
          ))}
        </SimpleGrid>
        <Alert
          status="warning"
          borderRadius="md"
          boxShadow="sm"
          maxW="container.md"
          mx="auto"
          my={15}
          mt={28}
          flexDirection={{ base: 'column', md: 'row' }}
        >
          <AlertIcon as={FaStar} />
          <Box flex="1" py={4} textAlign={{ base: 'center', md: 'left' }}>
            <AlertTitle fontSize="lg">Attività riservata ai soci</AlertTitle>
            <AlertDescription fontSize="md">
              Per partecipare è necessario essere tesserati. Se non sei ancora
              socio, effettua il tesseramento qui:
            </AlertDescription>
          </Box>
          <Button
            as={Link}
            to="/tesseramento"
            colorScheme="yellow"
            size="md"
            ml={{ base: 0, md: 4 }}
          >
            Tesserati Ora
          </Button>
        </Alert>
      </Container>
      <Box bg="blue.500" color="white" py={24} px={5} textAlign="center">
        <Heading fontSize="3xl" mb={6} color="ffcc00">
          🎉 Sconti 2025 🎉
        </Heading>
        <Text fontSize="lg" maxW="600px" mx="auto" mb={8}>
          Per rendere il nostro centro estivo più accessibile, offriamo{' '}
          {event.prezzoOriginale ? 'tre ' : 'due '}
          sconti speciali: uno per le famiglie con più figli iscritti e uno per
          chi partecipa a tutte le settimane!
        </Text>

        <SimpleGrid
          columns={{ base: 1, md: event.prezzoOriginale ? 3 : 2 }}
          spacing={6}
          maxW="90%"
          mx="auto"
        >
          {/* Sconto a Tempo Limitato */}
          {event.prezzoOriginale && (
            <VStack
              bg="green.200"
              p={6}
              borderRadius="md"
              boxShadow="lg"
              spacing={4}
              color="black"
              textAlign="center"
            >
              <Icon as={FaClock} w={12} h={12} color="green.600" />
              <Heading fontSize="2xl">Sconto a Tempo Limitato</Heading>
              <Text fontSize="md">
                Prenota entro il <strong>1° maggio 2025</strong> per bloccare il
                prezzo speciale di <strong>{event.prezzo}€</strong> a settimana!
                Anche se saldi dopo questa data, il prezzo scontato resterà
                garantito. Non perdere l’occasione!
              </Text>
            </VStack>
          )}
          {/* Sconto Fratelli */}
          <VStack
            bg="yellow.400"
            p={6}
            borderRadius="md"
            boxShadow="lg"
            spacing={4}
            color="black"
            textAlign="center"
          >
            <Icon as={FaUsers} w={12} h={12} color="yellow.700" />
            <Heading fontSize="2xl">Sconto Fratelli</Heading>
            <Text fontSize="md">
              <b>10% di sconto</b> sul saldo per il secondo figlio e successivi.
              Un&apos;opportunità per far vivere l’esperienza insieme!
            </Text>
          </VStack>

          {/* Pacchetto MVP */}
          <VStack
            bg="purple.200"
            p={6}
            borderRadius="md"
            boxShadow="lg"
            spacing={4}
            color="black"
            textAlign="center"
          >
            <Icon as={FaStar} w={12} h={12} color="purple.600" />
            <Heading fontSize="2xl">Pacchetto MVP</Heading>
            <Text fontSize="md">
              Prenota tutte le settimane per riceverle ad un prezzo{' '}
              <b>SUPER SCONTATO</b>!<br />
              Per ottenere lo sconto,{' '}
              <b>
                <u>seleziona tutte le settimane</u>
              </b>{' '}
              e scegli la variante &quot;totale&quot; al momento dell’iscrizione
              (è possibile rateizzare il pagamento!).
            </Text>
          </VStack>
        </SimpleGrid>
      </Box>

      {/* ATTIVITÀ E STRUTTURA DELLA GIORNATA */}
      <Container maxW="container.lg" py={20}>
        <Box bg="white" p={6} borderRadius="md" boxShadow="xl" mb={20}>
          <Heading size="lg" color="blue.600" textAlign="center" mb={3}>
            👥 Attività suddivise per fasce d’età
          </Heading>
          <Text textAlign="center" fontWeight="bold" mb={6}>
            I gruppi sono organizzati per garantire attività adatte a tutti.
          </Text>
          <Tabs variant="soft-rounded" colorScheme="teal">
            <TabList justifyContent="center">
              <Tab _selected={{ fontWeight: 'bold', bg: 'gray.200' }}>
                🧒 Gruppo Elementari
              </Tab>
              <Tab _selected={{ fontWeight: 'bold', bg: 'gray.200' }}>
                👦 Gruppo Medie
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel textAlign="center">
                <Text fontSize="sm" color="gray.600">
                  Attività creative e laboratori pensati per i più piccoli.
                </Text>
                <Text mt={3} fontWeight="bold" fontSize="sm">
                  🍎 Mercoledì – Merenda Condivisa
                </Text>
                <Text fontSize="sm" color="gray.600">
                  Ogni bambino porta una merenda da condividere.
                </Text>
              </TabPanel>
              <TabPanel textAlign="center">
                <Text fontSize="sm" color="gray.600">
                  Attività articolate, giochi di squadra e momenti di
                  esplorazione.
                </Text>
                <Text mt={3} fontWeight="bold" fontSize="sm">
                  🥗 Giovedì – Pranzo Condiviso
                </Text>
                <Text fontSize="sm" color="gray.600">
                  I ragazzi contribuiscono con un piatto per un pasto condiviso.
                </Text>
              </TabPanel>
            </TabPanels>
            <Text
              fontSize="sm"
              color="gray.600"
              align="center"
              fontWeight="bold"
              mt={4}
            >
              Alcune attività sono comuni a tutti i gruppi.
            </Text>
          </Tabs>
        </Box>

        <Box bg="white" p={6} borderRadius="md" boxShadow="lg" mb={6} mt={-3}>
          <Heading size="lg" color="blue.600" textAlign="center" mb={1}>
            🏃‍♂️ Attività Proposte
          </Heading>
          <Text textAlign="center" mb={4}>
            Un mix di esperienze per stimolare creatività e movimento.
          </Text>
          <SimpleGrid
            gap={{ base: 2, md: 4, lg: 6 }}
            columns={{ base: 1, md: 2, lg: 3 }}
            mt={8}
          >
            <WidgetCard
              icon={FaRunning}
              label="Giochi di movimento"
              value=""
              color="yellow.600"
              description="Attività fisiche e divertenti per stimolare il movimento."
            />
            <WidgetCard
              icon={FaPaintBrush}
              label="Laboratori manuali"
              color="purple.600"
              value=""
              description="Creatività e arte attraverso laboratori dedicati."
            />
            <WidgetCard
              icon={FaTheaterMasks}
              label="Attività teatrali"
              color="pink.600"
              value=""
              description="Espressione artistica e teatrale per tutti."
            />
            <WidgetCard
              icon={FaLaptop}
              label="Giochi multimediali"
              color="orange.600"
              value=""
              description="Esperienze interattive con la tecnologia."
            />
            <WidgetCard
              icon={FaTree}
              label="Esplorazione del Munlab"
              color="green.600"
              value=""
              description="Scopri l'ambiente naturale e culturale del Munlab."
            />
          </SimpleGrid>
        </Box>
      </Container>
      {/* SLIDER IMMAGINI */}
      <Container maxW="container.lg" py={10} textAlign="center">
        <Image
          src={sliderImages[currentImage]}
          alt="Centro Estivo"
          w="100%"
          h={{ base: '400px', lg: '500px' }}
          borderRadius="md"
          objectFit="cover"
          boxShadow="sm"
        />
        <Flex justify="center" mt={4}>
          <IconButton
            icon={<FaArrowLeft />}
            onClick={prevImage}
            mr={2}
            aria-label="Immagine precedente"
          />
          <IconButton
            icon={<FaArrowRight />}
            onClick={nextImage}
            aria-label="Immagine successiva"
          />
        </Flex>
      </Container>
      {/* INFO AGGIUNTIVE */}
      <Container maxW="container.lg" py={10} bg="blue.100" borderRadius={8}>
        <Heading size="lg" textAlign="center" mb={6} color="blue.600">
          ℹ️ Informazioni Aggiuntive
        </Heading>
        <Accordion allowToggle>
          {infoUtili.map((info) => (
            <AccordionItem
              key={info.id}
              border="1px"
              borderColor="gray.200"
              borderRadius="md"
              mb={2}
            >
              <AccordionButton
                _expanded={{ bg: 'blue.100' }}
                _hover={{ bg: 'blue.100' }}
                bg="blue.50"
              >
                <Flex flex="1" align="center" textAlign="left">
                  {info.icon}
                  <Text
                    ml={2}
                    fontWeight="semibold"
                    fontSize="md"
                    color="gray.700"
                  >
                    {info.title}
                  </Text>
                </Flex>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel bg="blue.50" pb={4}>
                {info.content}
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
      <Alert
        status="info"
        borderRadius={{ base: 'none', md: 'md' }}
        boxShadow="sm"
        maxW="container.lg"
        mx="auto"
        my={6}
      >
        <AlertIcon />
        <Box flex="1">
          <AlertTitle mt={2} mb={2} fontSize="md" color="blue.600">
            📢 Venerdì: Momento Conclusivo
          </AlertTitle>
          <AlertDescription fontSize="sm" color="gray.700" mb={2}>
            Ogni venerdì alle <strong>16:30</strong> aspettiamo i genitori per
            ripercorrere la settimana.
          </AlertDescription>

          <AlertDescription
            fontSize="sm"
            color="gray.700"
            fontWeight="semibold"
          >
            {' '}
            Segue un piccolo rinfresco per concludere al meglio!
          </AlertDescription>
        </Box>
      </Alert>

      {/* SPAZI E LOGISTICA */}
      <Container
        maxW={{ base: '100%', md: 'container.lg' }}
        py={10}
        px={{ base: 0, md: 4 }}
      >
        <Box
          bg="white"
          p={6}
          borderRadius={{ base: 0, md: 'md' }}
          boxShadow="sm"
          mb={6}
        >
          <Heading size="lg" color="blue.600" textAlign="center" mb={6}>
            🌿 Il Munlab, un ambiente sicuro e accogliente
          </Heading>
          <SimpleGrid
            columns={{ base: 1, md: 2 }}
            spacing={6}
            alignItems="center"
          >
            <Box>
              <Image
                src={munlab}
                alt="Munlab - Spazio Verde"
                borderRadius="md"
                boxShadow="sm"
                w="100%"
                objectFit="cover"
              />
            </Box>
            <Box textAlign="center">
              <Text fontSize="lg" mb={4}>
                <b>Attività in collaborazione con</b>
              </Text>
              <Image src={logoMunlab} alt="Munlab - Spazio Verde" p={8} />
              <Text fontSize="md" mb={4}>
                Il centro estivo si svolge presso il <b>Munlab</b>, un’ampia
                area verde con spazi coperti, ideale per ogni attività anche in
                caso di maltempo.
              </Text>
              <SimpleGrid>
                <Box textAlign="center">
                  <Text fontWeight="bold">🌳 Ampia area verde</Text>
                  <Text>Spazi immersi nella natura.</Text>
                </Box>
                <Box textAlign="center">
                  <Text fontWeight="bold" p={4}>
                    🏠 Zone coperte
                  </Text>
                  <Text>
                    Aree protette per laboratori e giochi in caso di pioggia.
                  </Text>
                </Box>
              </SimpleGrid>
              <Box textAlign="center" mt={6}>
                <Button
                  colorScheme="blue"
                  size="lg"
                  as="a"
                  href="https://www.munlabtorino.it/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Scopri di più
                </Button>
              </Box>
            </Box>
          </SimpleGrid>
        </Box>
      </Container>

      <Container maxW="container.md" py={2} mb={10}>
        <Box
          textAlign="center"
          bg="blue.100"
          p={6}
          borderRadius="md"
          boxShadow="sm"
        >
          <Text fontWeight="bold" mb={4}>
            Hai dubbi? Scopri le risposte alle domande più frequenti!
          </Text>
          <Button
            colorScheme="blue"
            size="lg"
            as={Link}
            to="/domande-frequenti"
          >
            Domande Frequenti
          </Button>
        </Box>
      </Container>

      <Container
        bg="yellow.200"
        p={6}
        borderRadius={{ base: 0, md: 'md' }}
        boxShadow="2xl"
        maxW="container.sm"
        py={10}
        mt={16}
      >
        {/* TESTIMONIANZE */}
        {/* Titolo e descrizione */}
        <Box textAlign="center" mb={6}>
          <Heading size="lg" color="blue.600">
            Testimonianze
          </Heading>
          <Text fontSize="md" color="gray.600">
            Scopri l’esperienza di chi ha già partecipato!
          </Text>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minH="120px"
        >
          <Text fontSize="lg" fontStyle="italic" textAlign="center">
            &quot;{testimonials[currentTestimonial].text}&quot;
          </Text>
          <Text fontWeight="bold" mt={2}>
            - {testimonials[currentTestimonial].author}
          </Text>
          <Flex mt={4}>
            <IconButton
              icon={<FaArrowLeft />}
              onClick={prevTestimonial}
              mr={2}
              aria-label="Testimonianza precedente"
              variant="solid"
              size="md"
            />
            <IconButton
              icon={<FaArrowRight />}
              onClick={nextTestimonial}
              aria-label="Testimonianza successiva"
              variant="solid"
              size="md"
            />
          </Flex>
        </Box>
      </Container>
      <Container maxW="container.lg" py={10} mt={16}>
        {/* STATISTICHE */}
        {/* Titolo e descrizione */}
        <Box textAlign="center" mb={6}>
          <Heading size="lg" color="blue.100">
            Statistiche 2024
          </Heading>
          <Text fontSize="md" color="gray.100">
            Qualche numero dall’ultima edizione del nostro centro estivo
          </Text>
        </Box>

        <StatGroup justifyContent="center" flexWrap="wrap" gap={6}>
          {[
            {
              id: 'ghiaccioli',
              label: 'Ghiaccioli consumati',
              value: '446',
            },
            {
              id: 'professionisti',
              label: 'Professionisti coinvolti',
              value: '13',
            },
            { id: 'ore', label: 'Ore di attività', value: '360' },
            { id: 'pasti', label: 'Pasti consumati', value: '608' },
          ].map((stat) => (
            <Stat
              key={stat.id}
              bg="blue.50"
              p={6}
              borderRadius="md"
              boxShadow="md"
              textAlign="center"
              minW={{ base: '100%', md: '200px' }}
              borderLeft="6px solid"
              borderColor="blue.600"
            >
              <StatNumber fontSize="3xl" color="blue.700" mb={2}>
                {stat.value}
              </StatNumber>
              <StatLabel fontSize="md" color="gray.700">
                {stat.label}
              </StatLabel>
            </Stat>
          ))}
        </StatGroup>
      </Container>

      {/* MODULO DI CONTATTO */}
      <Container maxW="container.lg" py={10}>
        <ContactForm
          title="Ancora qualche dubbio?"
          description="Compila il modulo qui sotto e ti risponderemo al più presto! Siamo felici di aiutarti con qualsiasi domanda su iscrizioni, attività e organizzazione."
          titleSize="lg"
        />
      </Container>
    </Box>
  );
};

export default CentroEstivo;
